<div class="filters" [ngClass]="{ show: showFilters }">
  <div class="content">
    <div class="form" *ngIf="_products.products">
      <!-- <form class="form" [formGroup]="filtersForm" (ngSubmit)="submitFilters()"> -->
      <button type="button" class="close" (click)="showFilters = false"><svg style="height: 20px; width: 20px;" class="icon" viewBox="0 0 512 512" ><use xlink:href="#times" x="0" y="0" /></svg></button>

      <h2 class="filters__header">FILTROWANIE I SORTOWANIE</h2>
        <div>
          <button class="mainFilterBtn" (click)="sortOpen = !sortOpen">Sortuj</button>
          <div *ngIf="sortOpen" class="mainFilter">
              <button class="filterBtn" [ngClass]="{ checked: sorting === 'default_se;desc' }" type="button" (click)="setSorting('default_se;desc')">
                  Domyślnie
              </button>


              <button class="filterBtn" [ngClass]="{ checked: sorting === 'name;asc' }" type="button" (click)="setSorting('name;asc')">
                  Alfabetycznie - rosnąco
              </button>
              <button class="filterBtn" [ngClass]="{ checked: sorting === 'name;desc' }" type="button" (click)="setSorting('name;desc')">
                  Alfabetycznie - malejąco
              </button>
              <button class="filterBtn" [ngClass]="{ checked: sorting === 'capacity;asc' }" type="button" (click)="setSorting('capacity;asc')">
                  Pojemność - rosnąco
              </button>
              <button class="filterBtn" [ngClass]="{ checked: sorting === 'capacity;desc' }" type="button" (click)="setSorting('capacity;desc')">
                  Pojemność - malejąco
              </button>
          </div>
        </div>

      <div *ngFor="let filter of displayFilters | keyvalue; let last = last">
        <button [disabled]="filter.value.type === currentType && currentCategory" class="mainFilterBtn" type="button" (click)="filter.value.open = !filter.value.open" [ngClass]="{ last: last, open: filter.value.open }">
          {{ filter.value.name }}
        </button>
        <div *ngIf="filter.value.open" class="mainFilter" [ngClass]="{ last: last }">

          <button *ngFor="let item of filter.value.items" class="filterBtn" [disabled]="item.enable === false" [ngClass]="{ checked: item.checked }" type="button" (click)="filterProducts(filter.key, item)">
            {{ item.name }}
          </button>

        </div>
      </div>

      <div class="row" style="margin-top: 30px;">
        <div class="col-6">
          <button class="btn btn--block btn--black" type="button" (click)="setFilters()">ZASTOSUJ</button>
        </div>
        <div class="col-6">
          <button class="btn btn--border btn--block" type="button" (click)="clearFilters()">WYCZYŚĆ FILTRY</button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="container">
  <div class="row">

    <div class="col-12 col-md-3">
      <nav class="sticky">
        <ul>
          <li>
            <button class="heading" (click)="currentOpen === 'produkty' ? (currentOpen = null) : (currentOpen = 'produkty')" [ngClass]="{ activeCategory: currentOpen === 'produkty' }">Produkty</button>
            <ul>

                <ng-container *ngFor="let item of _lists.data.produkty">
                    <li>
                        <a [routerLink]="['/produkty', item.slug]" routerLinkActive="active">{{ item.name }}</a>
                      </li>
                  </ng-container>

              <!-- <li *ngFor="let item of _lists.data.produkty"
                ><a [routerLink]="['/produkty', item.slug]" routerLinkActive="active">{{ item.name }}</a></li
              > -->
              <li><a [routerLink]="['/produkty']" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">Wszystkie</a></li>
            </ul>
          </li>
          <li>
            <button class="heading" (click)="currentOpen === 'efekty' ? (currentOpen = null) : (currentOpen = 'efekty')" [ngClass]="{ activeCategory: currentOpen === 'efekty' }">Efekty</button>
            <ul>
              <li *ngFor="let item of _lists.data.efekty"
                ><a [routerLink]="['/efekty', item.slug]" routerLinkActive="active">{{ item.name }}</a></li
              >
              <li><a [routerLink]="['/efekty']" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">Wszystkie</a></li>
            </ul>
          </li>
          <li>
            <button class="heading" (click)="currentOpen === 'gamy' ? (currentOpen = null) : (currentOpen = 'gamy')" [ngClass]="{ activeCategory: currentOpen === 'gamy' }">Gamy</button>
            <ul>
              <li *ngFor="let item of _lists.data.gamy"
                ><a [routerLink]="['/gamy', item.slug]" routerLinkActive="active">{{ item.name }}</a></li
              >
              <li><a [routerLink]="['/gamy']" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">Wszystkie</a></li>
            </ul>
          </li>
        </ul>
      </nav>
    </div>

    <ng-template #loading>
        <app-loading></app-loading>
    </ng-template>

    <div class="col-12 col-md-9" >

      <app-page-header *ngIf="!currentCategory" [header]="header"></app-page-header>


      <div class="row">
        <div class="col-12 col-sm-auto order-sm-last">

          <button (click)="showFilters = true" class="filterBtn  d-flex justify-content-start align-items-center"><strong>Filtrowanie i sortowanie</strong>
            <svg style="height: 20px; width: 20px;padding-left: 5px" class="icon" viewBox="0 0 512 512" ><use xlink:href="#sliders-h" x="0" y="0" /></svg>

          </button>
        </div>
        <div class="col-12 col-sm">
            <ng-container *ngFor="let category of displayFilters | keyvalue">
                <ng-container *ngIf="category.value.type !== currentType || (category.value.type === currentType && !currentCategory)">
                    <ng-container *ngFor="let filter of category.value.items">
                        <div *ngIf="filter.checked" class="checkedFilter">
                          {{ category.value.name }}: {{ filter.name }} <button (click)="filterProducts(category.key, filter)"><svg style="height: 20px; width: 20px;" class="icon" viewBox="0 0 512 512" ><use xlink:href="#times" x="0" y="0" /></svg></button>
                        </div>
                      </ng-container>
                </ng-container>
              </ng-container>
        </div>
      </div>

      <div *ngIf="data else loading">
        <p *ngIf="data.length === 0">Nie znaleziono produktów.</p>

        <div class="row" *ngIf="data.length > 0">
          <div class="col-12 col-sm-6 col-md-6 col-lg-4" *ngFor="let product of data">
            <app-product-box [product]="product"></app-product-box>
          </div>
        </div>
      </div>


    </div>
  </div>
</div>
